module.exports = __webpack_public_path__ + "static/favicon-8509facf95e75b80a0799ba1ef0f82cc.jpg";